import React from "react";
import { inject } from "mobx-react";
import { Component } from "react";
import { Card, Row, Col, Modal, Button } from "react-bootstrap";
import { observer } from "mobx-react";

//components
import withLocalization from "~/hoc/withLocalization";
import applicationRouter from "~/hoc/applicationRouter";

//elements
import Input from '~/elements/Input';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';

class BrokenRuleCardComp extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            selectedRule: {},
            reason: ''
        };
    }

    handleClose = () => {
        this.setState({
            showModal: false,
            reason: ''
        });
    };

    handleSend = () => {
        const { commonStore, t, saveExceptionReason } = this.props;
        if (!this.state.reason.trim()) return commonStore.addNotification(t('Please provide a reason.'), null, 'error');
        saveExceptionReason(Object.keys(this.state.selectedRule)[0], this.state.reason);
        this.setState({ showModal: false, reason: '' });
    };

    handleReasonChange = (e) => {
        this.setState({ reason: e.target.value });
    };

    handleRuleClick = (key, value) => {
        const { exceptionReasons } = this.props;
        const _selectedRule = { [key]: value };
        this.setState({ showModal: true, selectedRule: _selectedRule, reason: exceptionReasons && exceptionReasons[key] || '' });
    };

    render() {
        const { selectedRule, reason } = this.state;
        const { exceptions, exceptionReasons, isRosterDisabled, t } = this.props;

        const groupedExceptions = {
            dailyLimits: [],
            weeklyLimits: [],
            cycleLimits: [],
            restPeriodShifts: [],
            restPeriodWeeks: [],
            consecutiveSundays: [],
            consecutiveSaturday: [],
            publishedShiftChanged: [],
            freeCode: []
        };

        const categoryNames = {
            dailyLimits: t('Daily work limit exceeded'),
            weeklyLimits: t('Weekly work limit exceeded'),
            cycleLimits: t('Cycle work limit exceeded'),
            restPeriodShifts: t('Missing daily rest period'),
            restPeriodWeeks: t('Missing weekly rest period'),
            consecutiveSundays: t('Excessive consecutive Sunday shifts'),
            consecutiveSaturday: t('Excessive consecutive Saturday shifts'),
            publishedShiftChanged: t('Published Shift Changed'),
            freeCode: t('Free Code violations')
        };

        Object.entries(exceptions).forEach(([key, value]) => {
            if (key.includes('max_hours_limit_in_a_day')) groupedExceptions.dailyLimits.push({ key, value });
            else if (key.includes('mandatory_overtime_limit_per_week')) groupedExceptions.weeklyLimits.push({ key, value });
            else if (key.includes('cycle_work_hours_limit_exceed')) groupedExceptions.cycleLimits.push({ key, value });
            else if (key.includes('rest_between_shifts')) groupedExceptions.restPeriodShifts.push({ key, value });
            else if (key.includes('insufficient_rest_between_week')) groupedExceptions.restPeriodWeeks.push({ key, value });
            else if (key.includes('max_consecutive_working_sunday')) groupedExceptions.consecutiveSundays.push({ key, value });
            else if (key.includes('max_consecutive_working_saturday')) groupedExceptions.consecutiveSaturday.push({ key, value });
            else if (key.includes('shift_changed')) groupedExceptions.publishedShiftChanged.push({ key, value });
            else if (key.includes('_f1_missing') || key.includes('_f3_work_on_') ||
                key.includes('_f4_work_on_') || key.includes('_date_to_add_f5_') ||
                key.includes('f5_missing_overdue_after_f1'))
                groupedExceptions.freeCode.push({ key, value });
        });

        return (
            <>
                <Card style={{ borderRadius: '20px', fontSize: '14px' }}>
                    <Card.Header className="fs-15 w-100 m-0 text-white p-3 background-color-2550AC">
                        {t('Exceptions ( Broken Rules )')}
                    </Card.Header>
                    <Card.Body className="overflow-auto" style={{ maxHeight: 'calc(100dvh - 50dvh)' }}>
                        {Object.keys(groupedExceptions).map((groupKey, index) => {
                            const group = groupedExceptions[groupKey];
                            if (group.length === 0) return null;
                            return (
                                <div key={index} className="mb-3">
                                    <b className="text-danger">{categoryNames[groupKey]}</b>
                                    {group.map(({ key, value }, idx) => (
                                        <div key={idx}>
                                            <Row>
                                                <Col xs={11} md={10} lg={10}>
                                                    <div className="d-flex flex-column">
                                                        <span
                                                            className="text-decoration-underline cursor-pointer ms-4"
                                                            onClick={() => this.handleRuleClick(key, value)}
                                                        >
                                                            <i className="ms-2 fas fa-exclamation text-danger me-2"></i>
                                                            {value}
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col xs={1} md={2} lg={2}>
                                                    <i className="fa fa-info-circle fa-2x text-danger"></i>
                                                </Col>
                                            </Row>

                                            {exceptionReasons && exceptionReasons[key] && (
                                                <Row className="mb-1">
                                                    <Col xs={12}>
                                                        <Input
                                                            type="text"
                                                            value={exceptionReasons[key]}
                                                            onClick={() => this.handleRuleClick(key, value)}
                                                            className="cursor-pointer ms-5"
                                                            disabled={isRosterDisabled}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </Card.Body>
                </Card>

                <Modal centered show={this.state.showModal} onHide={this.handleClose}>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Exceptions')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            onClick={this.handleClose}
                            alt={"close button"}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className="timelog-array__right w-100">
                            <p className="text-danger fs-15">
                                {selectedRule && Object.values(selectedRule)[0]}
                            </p>
                            <b>{t('Why breaking this rule')}</b>
                            <textarea
                                className="form-control w-100 mt-1 p-3"
                                rows={8}
                                style={{ minHeight: '112px' }}
                                placeholder="Type message"
                                value={reason}
                                onChange={this.handleReasonChange}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                        <Button variant="primary" className="btn btn-fill btn-primary px-4 py-2" onClick={this.handleSend} disabled={isRosterDisabled}>
                            {t('Save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default inject('userStore', 'commonStore', 'scheduleStore', 'clientStore')(withLocalization(applicationRouter(observer(BrokenRuleCardComp))));
